import { render } from "./AddWaterMaskModal.vue?vue&type=template&id=7b616830"
import script from "./AddWaterMaskModal.vue?vue&type=script&lang=js"
export * from "./AddWaterMaskModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__